<template>
  <div
    v-if="typeLabel && typeIcon"
    id="info-request"
    class="info-request i-py-7 i-px-8 d-flex"
  >
    <div class="d-flex align-items-center i-mr-8">
      <i-icon :symbol="typeIcon" :size="16"></i-icon>
    </div>
    <div class="d-flex flex-column flex-grow-1">
      <p class="i-text-body-3 i-text-neutral-110">{{ typeLabel }}</p>
      <p
        :class="
          hasResponse
            ? 'i-text-button-3 i-text-neutral-120'
            : 'i-text-body-3 i-text-neutral-90'
        "
      >
        {{ responseText }}
      </p>
    </div>
    <div v-if="hasResponse" class="d-flex align-items-center copy-button">
      <i-icon-button
        id="copy-btn"
        symbol="small-edit-copy"
        size="sm"
        type="transparent"
        @button-click="copy(responseText)"
      />
      <b-tooltip
        target="copy-btn"
        placement="top"
        triggers="click"
        container="info-request"
      >
        Copied!
      </b-tooltip>
    </div>
  </div>
</template>

<script>
import { iIcon, iIconButton } from '@inscribe/signal';
import { copyText } from '@/utils/copyText';
import * as request from '@/constants/informationRequestTypes';

export default {
  components: {
    iIcon,
    iIconButton,
  },
  props: {
    type: {
      type: String,
      default: undefined,
    },
    response: {
      type: Array,
      default: undefined,
    },
  },
  computed: {
    hasResponse() {
      return this.response.length > 0;
    },
    responseText() {
      return this.hasResponse
        ? this.response[0].value.value
        : 'Awaiting customer response';
    },
    typeIcon() {
      return request.TYPE_MAP[this.type]
        ? request.TYPE_MAP[this.type]?.icon
        : undefined;
    },
    typeLabel() {
      return request.TYPE_MAP[this.type]
        ? request.TYPE_MAP[this.type]?.label
        : undefined;
    },
  },
  methods: {
    copy(text) {
      copyText(text);
      setTimeout(() => {
        this.$root.$emit('bv::hide::tooltip');
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.info-request {
  border: 1px solid $light-neutral-60;
  border-radius: 16px;

  .copy-button {
    opacity: 0;
  }
  .i-icon {
    color: $light-neutral-90 !important;
  }

  &:hover,
  &:focus {
    .copy-button {
      opacity: 1;
    }
  }
}
</style>
